import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-youtube",
  "use": "icon-youtube-usage",
  "viewBox": "0 0 30 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 21\" id=\"icon-youtube\"><path d=\"M11.9 14.4V6l8.1 4.2-8.1 4.2zm17.8-9.9s-.3-2.1-1.2-3C27.4.3 26.1.3 25.5.2 21.3 0 15 0 15 0S8.7 0 4.5.3c-.6.1-1.9.1-3 1.3-.9.9-1.2 3-1.2 3S0 6.9 0 9.4v2.3c0 2.4.3 4.8.3 4.8s.3 2.1 1.2 3c1.1 1.2 2.6 1.2 3.3 1.3 2.4.1 10.2.2 10.2.2s6.3 0 10.5-.3c.6-.1 1.9-.1 3-1.3.9-.9 1.2-3 1.2-3s.3-2.4.3-4.8V9.4c0-2.5-.3-4.9-.3-4.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol